import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetStations({ plant_name, make_model_id }) {
  return api
    .get(`/stations?plantName=${plant_name}&makeModelId=${make_model_id}`)
    .then((resp) => resp.data)
}

export function apiGetComponentStationMappings({
  componentAlias,
  makeModelId,
  plantName,
}) {
  const params = new URLSearchParams({
    componentAlias,
    makeModelId,
    plantName,
  })
  return api
    .get(`/component-station-mappings?${params.toString()}`)
    .then((resp) => resp.data)
}

// POST station_adjustments/bulk
export function apiPostBulkStationAdjustments({
  component_alias,
  plant_name,
  make_model_id,
  assignments,
}) {
  const payload = {
    component_alias: component_alias,
    plant_name: plant_name,
    make_model_id: make_model_id,
    assignments: assignments,
  }
  return api
    .post(`/station_adjustments/bulk`, payload)
    .then((resp) => resp.data)
}

// POST station_adjustments/reset
export function apiResetStationAdjustments({
  component_alias,
  plant_name,
  make_model_id,
}) {
  const payload = {
    component_alias: component_alias,
    plant_name: plant_name,
    make_model_id: make_model_id,
  }
  return api
    .post(`/station_adjustments/reset`, payload)
    .then((resp) => resp.data)
}
